import { DiscountBannerProps } from '../../types/components/pricing/DiscountBanner';

export const monthlyDiscountText = 'Get 30% off for the first 6 months';
export const yearlyDiscountText = 'Get 30% off for the first year';

import { ENV } from '../../constants/environments';

const DiscountBanner: React.FC<DiscountBannerProps> = ({
  plan,
  freeForever,
}) => {
  if (freeForever || ENV.displaySaleBanner !== 'true') return;

  const getBannerText = (): string => {
    switch (plan?.interval) {
      case 'month':
        return monthlyDiscountText;
      case 'year':
      default:
        return yearlyDiscountText;
    }
  }

  return (
    <div cy-test-id="discount-banner" className="bg-red-800 w-full py-2 text-12 text-white font-semibold text-center absolute top-0 right-0">
      {getBannerText()}
    </div>
  );
};

export default DiscountBanner;
